import * as tslib_1 from "tslib";
import { ErrorHandler, EventEmitter, OnInit } from '@angular/core';
import { ActionIconComponent } from '../action-icon/action-icon.component';
import { State } from '../state-view/state.model';
import { AuthService } from '../../auth/auth/auth.service';
import { UserService } from '../user/user.service';
import { MatSnackBar } from '@angular/material';
import { Review } from '../models/review.model';
var ThumbsdownIconComponent = /** @class */ (function () {
    function ThumbsdownIconComponent(_auth, _userService, _errorHandler, _snackBar) {
        this._auth = _auth;
        this._userService = _userService;
        this._errorHandler = _errorHandler;
        this._snackBar = _snackBar;
        this.toggle = new EventEmitter();
        this.authenticated = false;
        this.state = State.Empty;
    }
    ThumbsdownIconComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Update state based on latest event in authStream, and subscribe to any future
        // changes in authentication state.
        this._onAuthEvent(this._auth.authStream.getValue());
        this._auth.authStream.subscribe(function (e) { return _this._onAuthEvent(e); });
        // Update state based on latest available userInfo, and subscribe to any future
        // changes to userInfo.
        this._userInfo = this._userService.userInfo.getValue();
        this._userService.userInfo.subscribe(function (u) {
            // Update userInfo
            _this._userInfo = u;
            // Set state to loaded
            _this.state = State.Content;
        });
    };
    Object.defineProperty(ThumbsdownIconComponent.prototype, "isThumbset", {
        get: function () {
            return this._userInfo && (this.isLiked);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ThumbsdownIconComponent.prototype, "tooltip", {
        get: function () {
            return this.isLiked
                ? 'You disliked this comment' +
                    '(click to remove)'
                : 'Dislike this comment';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ThumbsdownIconComponent.prototype, "icon", {
        get: function () {
            return 'thumb_down';
        },
        enumerable: true,
        configurable: true
    });
    ThumbsdownIconComponent.prototype._onAuthEvent = function (e) {
        this.authenticated = this._auth.authenticated;
        if (this.authenticated && !this._auth.endUser) {
            // userInfo is not available when not authenticated as an end user, so set favorite state to loaded now.
            this.state = State.Content;
        }
    };
    ThumbsdownIconComponent.prototype.toggleSetting = function (v) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var snackBarOpts, response, response, response, response, e_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._auth.authenticated || !this._auth.endUser) {
                            this._auth.redirectToLogin();
                            return [2 /*return*/];
                        }
                        this.state = State.Loading;
                        snackBarOpts = { duration: 2000 };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 12, , 13]);
                        if (!this.review.interactions.myDownVote) return [3 /*break*/, 6];
                        if (!this.isAirport) return [3 /*break*/, 3];
                        return [4 /*yield*/, this._userService.setAirportInteraction(this.entityId, this.review.id, 'ClearVote')];
                    case 2:
                        response = _a.sent();
                        this.review = Review.parse(response);
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this._userService.setBusinessInteraction(this.entityId, this.review.id, 'ClearVote')];
                    case 4:
                        response = _a.sent();
                        this.review = Review.parse(response);
                        _a.label = 5;
                    case 5:
                        this.isLiked = false;
                        return [3 /*break*/, 11];
                    case 6:
                        if (!this.isAirport) return [3 /*break*/, 8];
                        return [4 /*yield*/, this._userService.setAirportInteraction(this.entityId, this.review.id, 'DownVote')];
                    case 7:
                        response = _a.sent();
                        this.review = Review.parse(response);
                        return [3 /*break*/, 10];
                    case 8: return [4 /*yield*/, this._userService.setBusinessInteraction(this.entityId, this.review.id, 'DownVote')];
                    case 9:
                        response = _a.sent();
                        this.review = Review.parse(response);
                        _a.label = 10;
                    case 10:
                        this.isLiked = true;
                        _a.label = 11;
                    case 11:
                        this.state = State.Content;
                        this.toggle.emit(this.review);
                        return [3 /*break*/, 13];
                    case 12:
                        e_1 = _a.sent();
                        this._snackBar.open('An error occurred saving your dislike/downVote. Please try again later.', 'Dismiss', snackBarOpts);
                        this._errorHandler.handleError(e_1);
                        // Set state to error, then reset after a few seconds to allow retry.
                        this.state = State.Error;
                        setTimeout(function () {
                            _this.state = State.Content;
                        }, 2000);
                        return [3 /*break*/, 13];
                    case 13: return [2 /*return*/];
                }
            });
        });
    };
    return ThumbsdownIconComponent;
}());
export { ThumbsdownIconComponent };
